import api from '@/api';

export default {
  namespaced: true,
  state: {
    user: {},
    period: {},
    exam: {},
    userInitFlags: {
      navigator: false,
      permission: false,
      loadFRModel: false,
      stream: false,
      device: false,
    },
    userLogs: null,
  },
  getters: {
    getUser(state) {
      return state.user;
    },
    isIdCardRegistered(state) {
      return state.user.registeredIdCard === 'Y';
    },
    isFaceRegistered(state) {
      return state.user.registeredFaceImage !== null;
    },
    getPeriod(state) {
      return state.period;
    },
    getExam(state) {
      return state.exam;
    },
    getUserInitFlags(state) {
      return state.userInitFlags;
    },
    getUserLogs(state) {
      return state.userLogs;
    },
  },
  mutations: {
    setUser(state, payload) {
      state.user = payload;
    },
    setUserFaceImage(state, payload) {
      state.user.registeredFaceImage = payload;
    },
    setExamPeriod(state, payload) {
      state.period = payload;
    },
    setExam(state, payload) {
      state.exam = payload;
    },
    setUserInitFlags(state, payload) {
      state.userInitFlags = {...state.userInitFlags, ...payload};
    },
    setUserLogs(state, payload) {
      state.userLogs = {...state.userLogs, ...payload};
    },
  },
  actions: {
    getUserInfo(context, payload) {
      return api.userDetail(payload).then(response => {
        if (response.status === 200) {
          const userData = response.data;
          context.commit('setUser', userData);
          return userData;
        }
      });
    },
    initUserIdCard(context, payload) {
      return api.userIdCardReRegistration(payload).then(() => {
        return context.dispatch('getUserInfo', payload);
      });
    },
    getExamPeriod(context, payload) {
      return api.examPeriodDetail(payload).then(response => {
        const resTime = response.headers['date'];
        const periodData = {resTime, ...response.data};
        context.commit('setExamPeriod', periodData);
        return periodData;
      });
    },
    getExamInfo(context, payload) {
      return api.examDetail(payload).then(response => {
        if (response.status === 200) {
          const examData = response.data;
          context.commit('setExam', examData);
          return examData;
        } else {
          // alert
        }
      });
    },
  },
};
